document.addEventListener('DOMContentLoaded', function () {
  const builder = document.querySelector('[data-att-builder]');

  if (!builder || !window.AristeoBuilder) return;

  const main = builder.querySelector('[data-att-main]');
  const stepButtons = builder.querySelectorAll('[data-att-step-button]');
  const stepLabel = builder.querySelector('[data-att-step-label]');
  const stepTitle = builder.querySelector('[data-att-step-title]');
  const searchInput = builder.querySelector('[data-att-search]');
  const filters = builder.querySelector('[data-att-filters]');
  const grid = builder.querySelector('[data-att-grid]');

  const sidebar = builder.querySelector('[data-att-sidebar]');
  const summary = builder.querySelector('[data-att-summary]');
  const closeBoxButton = builder.querySelector('[data-att-close-box]');
  const openBoxButton = builder.querySelector('[data-att-open-box]');
  const overlay = builder.querySelector('[data-att-overlay]');

  const countElement = builder.querySelector('[data-att-count]');
  const peopleElement = builder.querySelector('[data-att-people]');
  const balanceElement = builder.querySelector('[data-att-balance]');
  const totalElement = builder.querySelector('[data-att-total]');
  const cartButton = builder.querySelector('[data-att-cart]');

  const mobileCount = builder.querySelector('[data-att-mobile-count]');
  const mobileTotal = builder.querySelector('[data-att-mobile-total]');

  let activeCategory = 'quesos';
  let activeFilter = 'todos';
  let searchTerm = '';

  const selectedProducts = [];

  const categoryConfig = {
    quesos: {
      label: 'Paso 1',
      title: 'Elige tus quesos',
      search: 'Buscar un queso...'
    },

    charcuteria: {
      label: 'Paso 2',
      title: 'Elige tu charcutería',
      search: 'Buscar charcutería...'
    },

    acompanamientos: {
      label: 'Paso 3',
      title: 'Elige tus acompañamientos',
      search: 'Buscar un acompañamiento...'
    }
  };

  const categoryNames = {
    quesos: 'Quesos',
    charcuteria: 'Charcutería',
    acompanamientos: 'Acompañamientos'
  };

  const cheeseFilterCollections = {
    vaca: 'quesos-de-vaca',
    cabra: 'quesos-de-cabra',
    oveja: 'quesos-de-oveja',
    favoritos: 'favoritos-de-aristeo'
  };

  const moneyFormatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN'
  });

  stepButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const category = button.dataset.attStepButton;

      if (!categoryConfig[category]) return;

      activeCategory = category;
      activeFilter = 'todos';
      searchTerm = '';

      stepButtons.forEach(function (item) {
        item.classList.toggle(
          'is-active',
          item.dataset.attStepButton === category
        );
      });

      stepLabel.textContent = categoryConfig[category].label;
      stepTitle.textContent = categoryConfig[category].title;

      searchInput.value = '';
      searchInput.placeholder = categoryConfig[category].search;

      resetFilters();

      filters.hidden = category !== 'quesos';

      renderProducts();

      main.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });

  searchInput.addEventListener('input', function () {
    searchTerm = searchInput.value.trim().toLowerCase();
    renderProducts();
  });

  filters
    .querySelectorAll('[data-att-filter]')
    .forEach(function (button) {
      button.addEventListener('click', function () {
        activeFilter = button.dataset.attFilter || 'todos';

        filters
          .querySelectorAll('[data-att-filter]')
          .forEach(function (item) {
            item.classList.toggle(
              'is-active',
              item === button
            );
          });

        renderProducts();
      });
    });

  function resetFilters() {
    filters
      .querySelectorAll('[data-att-filter]')
      .forEach(function (button) {
        button.classList.toggle(
          'is-active',
          button.dataset.attFilter === 'todos'
        );
      });
  }

  function productIsSelected(productId) {
    return selectedProducts.some(function (product) {
      return product.id === Number(productId);
    });
  }

  function matchesActiveFilter(product) {
    if (
      activeCategory !== 'quesos' ||
      activeFilter === 'todos'
    ) {
      return true;
    }

    const requiredCollection =
      cheeseFilterCollections[activeFilter];

    if (!requiredCollection) return true;

    return Array.isArray(product.collections) &&
      product.collections.includes(requiredCollection);
  }

  function getVisibleProducts() {
    const products =
      window.AristeoBuilder[activeCategory] || [];

    return products.filter(function (product) {
      const matchesSearch = product.title
        .toLowerCase()
        .includes(searchTerm);

      return matchesSearch && matchesActiveFilter(product);
    });
  }

  function renderProducts() {
    const visibleProducts = getVisibleProducts();

    const selectedVisibleProducts = visibleProducts.filter(
      function (product) {
        return productIsSelected(product.id);
      }
    );

    const unselectedVisibleProducts = visibleProducts.filter(
      function (product) {
        return !productIsSelected(product.id);
      }
    );

    grid.innerHTML = '';

    if (visibleProducts.length === 0) {
      grid.innerHTML = `
        <div class="att-empty-state">
          No encontramos productos con esa búsqueda o filtro.
        </div>
      `;

      return;
    }

    if (selectedVisibleProducts.length > 0) {
      appendGroup(
        `En tu caja · ${selectedVisibleProducts.length}`,
        selectedVisibleProducts,
        true
      );
    }

    appendGroup(
      selectedVisibleProducts.length > 0
        ? `Más ${categoryNames[activeCategory].toLowerCase()}`
        : categoryNames[activeCategory],
      unselectedVisibleProducts,
      false
    );
  }

  function appendGroup(title, products, selectedGroup) {
    if (products.length === 0) return;

    const group = document.createElement('section');

    group.className = selectedGroup
      ? 'att-product-group att-product-group--selected'
      : 'att-product-group';

    const heading = document.createElement('h3');
    heading.className = 'att-product-group__title';
    heading.textContent = title;

    const productsContainer = document.createElement('div');
    productsContainer.className = 'att-product-group__grid';

    products.forEach(function (product) {
      productsContainer.appendChild(
        createProductCard(product)
      );
    });

    group.appendChild(heading);
    group.appendChild(productsContainer);
    grid.appendChild(group);
  }

  function createProductCard(product) {
    const isSelected = productIsSelected(product.id);

    const card = document.createElement('article');

    card.className = isSelected
      ? 'att-product-card is-selected'
      : 'att-product-card';

    card.innerHTML = `
      <a
        class="att-product-image"
        href="${escapeHtml(product.url || '#')}"
        aria-label="${escapeHtml(product.title)}"
      >
        ${
          product.image
            ? `
              <img
                src="${escapeHtml(product.image)}"
                alt="${escapeHtml(product.title)}"
                loading="lazy"
              >
            `
            : ''
        }
      </a>

      <div class="att-product-content">

        <h3>${escapeHtml(product.title)}</h3>

        ${
          product.gramaje
            ? `
              <p class="att-product-meta">
                ${escapeHtml(String(product.gramaje))}
              </p>
            `
            : ''
        }

        <p class="att-product-price">
          ${moneyFormatter.format(
            Number(product.price) / 100
          )}
        </p>

        <button
          class="att-card-action ${
            isSelected ? 'is-selected' : ''
          }"
          type="button"
          aria-label="${
            isSelected
              ? `Quitar ${escapeHtml(product.title)}`
              : `Añadir ${escapeHtml(product.title)}`
          }"
        >
          <span class="att-card-action__desktop">
            ${isSelected ? '✓ En tu caja' : 'Añadir'}
          </span>

          <span class="att-card-action__mobile">
            ${isSelected ? '×' : '+'}
          </span>
        </button>

      </div>
    `;

    card
      .querySelector('.att-card-action')
      .addEventListener('click', function () {
        toggleProduct(product);
      });

    return card;
  }

  function toggleProduct(product) {
    const productId = Number(product.id);

    const existingIndex = selectedProducts.findIndex(
      function (selectedProduct) {
        return selectedProduct.id === productId;
      }
    );

    if (existingIndex >= 0) {
      selectedProducts.splice(existingIndex, 1);
    } else {
      selectedProducts.push({
        id: productId,
        title: product.title,
        price: Number(product.price),
        image: product.image || '',
        gramaje: product.gramaje || '',
        category: activeCategory,
        quantity: 1
      });
    }

    renderProducts();
    renderSummary();
  }

  function removeProduct(productId) {
    const index = selectedProducts.findIndex(
      function (product) {
        return product.id === Number(productId);
      }
    );

    if (index === -1) return;

    selectedProducts.splice(index, 1);

    renderProducts();
    renderSummary();
  }

  function renderSummary() {
    summary.innerHTML = '';

    if (selectedProducts.length === 0) {
      summary.innerHTML = `
        <p class="att-summary__empty">
          Todavía no has elegido productos.
        </p>
      `;

      updateStats();
      return;
    }

    Object.keys(categoryNames).forEach(function (category) {
      const products = selectedProducts.filter(
        function (product) {
          return product.category === category;
        }
      );

      if (products.length === 0) return;

      const group = document.createElement('div');
      group.className = 'att-summary-group';

      group.innerHTML = `
        <h3 class="att-summary-group__title">
          ${categoryNames[category]}
        </h3>
      `;

      products.forEach(function (product) {
        const item = document.createElement('div');

        item.className = 'att-summary-item';

        item.innerHTML = `
          ${
            product.image
              ? `
                <img
                  class="att-summary-item__image"
                  src="${escapeHtml(product.image)}"
                  alt="${escapeHtml(product.title)}"
                  loading="lazy"
                >
              `
              : ''
          }

          <div class="att-summary-item__info">

            <p class="att-summary-item__title">
              ${escapeHtml(product.title)}
            </p>

            <p class="att-summary-item__meta">
              ${escapeHtml(product.gramaje || '')}
            </p>

            <p class="att-summary-item__price">
              ${moneyFormatter.format(
                product.price / 100
              )}
            </p>

          </div>

          <button
            class="att-summary-item__remove"
            type="button"
            aria-label="Quitar ${escapeHtml(product.title)}"
          >
            ×
          </button>
        `;

        item
          .querySelector('.att-summary-item__remove')
          .addEventListener('click', function () {
            removeProduct(product.id);
          });

        group.appendChild(item);
      });

      summary.appendChild(group);
    });

    updateStats();
  }

  function updateStats() {
    const productCount = selectedProducts.reduce(
      function (total, product) {
        return total + product.quantity;
      },
      0
    );

    const totalPrice = selectedProducts.reduce(
      function (total, product) {
        return total +
          product.price * product.quantity;
      },
      0
    );

    countElement.textContent = productCount;
    totalElement.textContent =
      moneyFormatter.format(totalPrice / 100);

    mobileCount.textContent =
      productCount === 1
        ? '1 producto'
        : `${productCount} productos`;

    mobileTotal.textContent =
      moneyFormatter.format(totalPrice / 100);

    openBoxButton.disabled = productCount === 0;
    cartButton.disabled = productCount === 0;

    if (productCount === 0) {
      peopleElement.textContent = '—';
      balanceElement.textContent = 'Por definir';
    } else if (productCount <= 2) {
      peopleElement.textContent = '2 personas';
      balanceElement.textContent = 'Sigue eligiendo';
    } else if (productCount <= 4) {
      peopleElement.textContent = '2–4 personas';
      balanceElement.textContent = 'Buena base';
    } else if (productCount <= 6) {
      peopleElement.textContent = '4–6 personas';
      balanceElement.textContent = 'Muy completa';
    } else {
      peopleElement.textContent = '6–8 personas';
      balanceElement.textContent = 'Caja abundante';
    }
  }

  function openBox() {
    sidebar.classList.add('is-open');
    overlay.classList.add('is-visible');

    sidebar.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(
      'att-drawer-open'
    );
  }

  function closeBox() {
    sidebar.classList.remove('is-open');
    overlay.classList.remove('is-visible');

    sidebar.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(
      'att-drawer-open'
    );
  }

  openBoxButton.addEventListener('click', openBox);
  closeBoxButton.addEventListener('click', closeBox);
  overlay.addEventListener('click', closeBox);

  cartButton.addEventListener('click', async function () {
    if (selectedProducts.length === 0) return;

    const items = selectedProducts.map(function (product) {
      return {
        id: product.id,
        quantity: product.quantity,
        properties: {
          'Caja personalizada': 'Crea tu caja'
        }
      };
    });

    try {
      cartButton.disabled = true;
      cartButton.textContent = 'Agregando…';

      const root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      const response = await fetch(
        `${root}cart/add.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json'
          },

          body: JSON.stringify({
            items: items
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          'No fue posible agregar los productos.'
        );
      }

      window.location.href = `${root}cart`;
    } catch (error) {
      console.error(error);

      alert(
        'No fue posible agregar la caja. Intenta de nuevo.'
      );

      cartButton.disabled = false;
      cartButton.textContent =
        'Agregar mi caja al carrito';
    }
  });

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  resetFilters();
  renderProducts();
  renderSummary();
});